/**
 * In this file, we create a React component
 * which incorporates components providedby material-ui.
 */

import React from 'react';
import ReactFireMixin from 'reactfire';
import Firebase from 'firebase';
import Moment from 'moment';
import RaisedButton from 'material-ui/RaisedButton';
import ActionGrade from 'material-ui/svg-icons/action/grade';
import {white} from 'material-ui/styles/colors';
import TextField from 'material-ui/TextField';
import ListItem from 'material-ui/List/ListItem';
import List from 'material-ui/List/List';
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import Dialog from 'material-ui/Dialog';
import Infinite from 'react-infinite';



const styles = {
  container: {
    textAlign: 'center',
    paddingTop: 200,
  },
};

var firebaseUrl = "https://dazzling-fire-840.firebaseio.com/";


const muiTheme = getMuiTheme({
  palette: {
    color: '#fff'
  },
});

var CommentSecondary = React.createClass({
  render: function(){
    return <div style={{color: '#ddd', fontSize: '16px'}}>{Moment(this.props.data.timestamp).fromNow()}</div>
  }
});


var CommentBox = React.createClass({
  mixins: [ReactFireMixin],

  getInitialState: function() {
    return {
      data: [],
      hasMore: true,
      modalOpen: false,
      isInfiniteLoading: false,
      numElements: 50,
      elements: [],
      fb: new Firebase(firebaseUrl + 'messages')
    };
  },

  componentWillMount: function() {
    // Here we bind the component to Firebase and it handles all data updates,
    // no need to poll as in the React example.
    var authData = this.state.fb.getAuth();
    if (authData) {
      console.log("Authenticated user with uid:", authData.uid);
      this.initLoad();
    }else{
      this.setState({modalOpen: true});
    }
  },

  initLoad: function(){
    var query;
    if(window.location.search.indexOf('date=') >= 0){
      var date = Moment(window.location.search.substring(window.location.search.indexOf('date=') + 5), "YYYY-MM-DD");
      if(!date.isValid()){
        date = Date.now() - 1000 * 60 * 60 * 24;
      }else{
        date = Date.parse(date.format());
      }
      query = this.state.fb.orderByChild('timestamp').startAt(date).limitToLast(50);
      query.on('child_added', function(dataSnapshot) {
        var message = dataSnapshot.val();
        message['.key'] = dataSnapshot.key();
        var data = this.state.data.concat([message]).sort(function(a, b){return b.timestamp-a.timestamp});
        this.setState({data: data});
      }, this);
    }else{
      query = this.state.fb.orderByChild('timestamp').limitToLast(50);
      query.on('child_added', function(dataSnapshot) {
        var message = dataSnapshot.val();
        message['.key'] = dataSnapshot.key();
        var data = this.state.data.concat([message]).sort(function(a, b){return b.timestamp-a.timestamp});
        this.setState({data: data});
      }, this);
    }
  },

  handleInfiniteLoad: function(callback){
    if(this.state.data.length === this.state.numElements){
      var query = this.state.fb.orderByChild('timestamp').endAt(this.state.data[this.state.data.length-1].timestamp - 1).limitToLast(50);
        query.on('child_added', function(dataSnapshot) {
          var message = dataSnapshot.val();
          message['.key'] = dataSnapshot.key();
          var data = this.state.data.concat([message]).sort(function(a, b){return b.timestamp-a.timestamp});
          this.setState({data: data, isInfiniteLoading: false, numElements: this.state.numElements+1});
        }, this);
    }
  },

  onTouchTapHandler: function(event, comment){
    event.preventDefault();
    if(comment){
      comment.selected = comment.selected ? false : true;
      var ref = new Firebase(firebaseUrl + 'messages/' + comment['.key']);
      ref.update({selected: comment.selected});
      this.state.data[this.state.data.indexOf(comment)] = comment;
      this.setState({data: this.state.data});
    }
  },

  elementInfiniteLoad: function() {
      return <div className="cs-loader">
              <div className="cs-loader-inner">
                <label>	●</label>
                <label>	●</label>
                <label>	●</label>
                <label>	●</label>
                <label>	●</label>
                <label>	●</label>
              </div>
            </div>;
  },

  renderItems: function(array, comment, key) {
    var self = this;
    return this.state.data.map(function (comment, index) {
      return <ListItem style={{color: '#fff', fontSize: '26px', fontWeight: '600', lineHeight: '28px'}} primaryText={comment.Body} secondaryText={<CommentSecondary data={comment} />} key={index} leftIcon={<ActionGrade style={{fill: comment.selected ? '#0B687C' : '#ddd'}} />} onTouchTap={function(event){ self.onTouchTapHandler(event, comment); }}/>;
    },this);
  },

  handleLogin: function(event) {
    event.preventDefault();
    var email = this.refs.email.input.value.trim(),
    password = this.refs.password.input.value.trim(),
    ref = new Firebase(firebaseUrl);

    if(email && password){
      this.state.fb.authWithPassword({
        "email": email,
        "password": password
      }, function(error, authData) {
        if (error) {
          console.log("Login Failed!", error);
          this.refs.password.input.value = '';
        } else {
          console.log("Authenticated successfully with payload:", authData);
          this.setState({modalOpen: false});
          this.initLoad();
          this.refs.email.input.value = '';
          this.refs.password.input.value = '';
        }
      }.bind(this));

    }
  },

  render: function() {
    const actions = [
      <RaisedButton
        label="Cancel"
        style={{margin: '10px 15px'}}
        onTouchTap={this.handleModalClose}
      />,
      <RaisedButton
        label="Submit"
        primary={true}
        style={{margin: '10px 15px'}}
        onTouchTap={this.handleLogin}
      />,
    ];
    var comments = this.renderItems();
    return (
      <MuiThemeProvider muiTheme={muiTheme}>
      <div>
      <div className="list">
      <div className="commentList"><List>
              <Infinite elementHeight={100}
              useWindowAsScrollContainer={true}
                 infiniteLoadBeginEdgeOffset={200}
                 onInfiniteLoad={this.handleInfiniteLoad}
                 loadingSpinnerDelegate={this.elementInfiniteLoad()}
                 timeScrollStateLastsForAfterUserScrolls={1000}
                 isInfiniteLoading={this.state.isInfiniteLoading}>{comments}</Infinite></List></div>
      </div>
      <Dialog
          title="Login"
          actions={actions}
          modal={true}
          open={this.state.modalOpen}>
          <div className="form">
          <TextField hintText="Email" ref="email" id="email" inputStyle={{fontFamily: 'sofia-pro', fontWeight: '600', fontSize: '22px'}} hintStyle={{ fontFamily: 'sofia-pro', fontWeight: '600', fontSize: '22px'}} fullWidth={true} className=""/><br/><br/>
          <TextField hintText="Password" type="password" ref="password" id="password" inputStyle={{fontFamily: 'sofia-pro', fontWeight: '600', fontSize: '22px'}} hintStyle={{fontFamily: 'sofia-pro', fontWeight: '600', fontSize: '22px'}} fullWidth={true} className=""/>
          </div>
        </Dialog>
        </div>
      </MuiThemeProvider>
    );
  }
});

export default CommentBox;



/** WEBPACK FOOTER **
 ** ./src/app/List.js
 **/